export function flattenProductRoadmapDays(roadmapRef) {
  const phases = roadmapRef?.phases || [];
  let absoluteIndex = 0;

  return phases.flatMap((phase, phaseIndex) =>
    (phase.weeks || []).flatMap((week) =>
      (week.days || []).map((day) => {
        const value = {
          ...day,
          phaseKey: phase.phaseKey || phase.id || "",
          phaseOrder: phase.order,
          phaseTitle: phase.title,
          phaseIndex,
          weekNumber: week.week,
          weekTitle: week.title,
          weekFeatureFocus: week.featureFocus || "",
          absoluteIndex,
        };
        absoluteIndex += 1;
        return value;
      })
    )
  );
}

export function getProductRoadmapStartDate(startedAt) {
  if (!startedAt) return null;
  const raw = startedAt.toDate ? startedAt.toDate() : new Date(startedAt);
  return new Date(raw.getFullYear(), raw.getMonth(), raw.getDate());
}

export function getProductRoadmapDateKey(date) {
  const local = new Date(date);
  local.setHours(0, 0, 0, 0);
  return local.toISOString().slice(0, 10);
}

export function getProductRoadmapDayDate(startedAt, absoluteIndex) {
  const start = getProductRoadmapStartDate(startedAt);
  if (!start) return null;

  const date = new Date(start);
  date.setDate(start.getDate() + absoluteIndex);
  return date;
}

export function getProductRoadmapCurrentDay(startedAt) {
  if (!startedAt) return 1;
  const start = getProductRoadmapStartDate(startedAt);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return Math.max(
    Math.floor((today - start) / (1000 * 60 * 60 * 24)) + 1,
    1
  );
}

export function withProductRoadmapDates(days, startedAt, completedDays = {}) {
  const currentDay = getProductRoadmapCurrentDay(startedAt);

  return days.map((day, index) => {
    const date = getProductRoadmapDayDate(startedAt, index);
    const dateKey = date ? getProductRoadmapDateKey(date) : null;
    const completed = dateKey ? !!completedDays[dateKey] : false;
    const unlocked = !startedAt ? index === 0 : index <= currentDay - 1;

    return {
      ...day,
      date,
      dateKey,
      completed,
      unlocked,
      status: completed
        ? "completed"
        : index + 1 === currentDay
        ? "today"
        : index + 1 < currentDay
        ? "missed"
        : "upcoming",
    };
  });
}
